import * as React from 'react';

export const HistoryContext = React.createContext<any>(history);



// WEBPACK FOOTER //
// ./src/webportal/components/contextProviders/HistoryContext.tsx